import type { FC } from "react";

import ImageLoader, { type IImageLoader } from "@Components/ImageLoader";
import type { QueryMdMax, QuerySmMax, QueryXsMax } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

import { TransitionLink } from "../common/Transition";

const mdMax: QueryMdMax = "@media (max-width: 1239px)";
const smMax: QuerySmMax = "@media (max-width: 989px)";
const xsMax: QueryXsMax = "@media (max-width: 759px)";

const styles = stylex.create({
    wrapper: {
        position: "relative",
    },

    header: {
        paddingBlock: "0",
        paddingInline: "10px",
        lineHeight: 1.2,
        textAlign: "center",
        height: "75px",
    },

    title: {
        marginBlock: "12px",
        marginInline: "0",
    },
    description: {
        color: "#999",
        fontSize: "0.875rem",
        fontWeight: 300,
    },
    newFlyer: {
        backgroundColor: "#00cb53",

        color: "white",
        position: "absolute",
        textAlign: "center",

        textTransform: "uppercase",

        zIndex: 1,
        borderBottomColor: "white",
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0",
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        width: "100%",
    },

    button: {
        borderColor: "#ccc",

        borderRadius: "5px",
        borderStyle: "solid",
        borderWidth: "1px",

        overflow: "hidden",
        textAlign: "center",
        height: {
            default: "550px",
            [mdMax]: "440px",
            [smMax]: "1010px",
            [xsMax]: "calc(100vw + 80px)",
        },
    },
    link: {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        height: "100%",
        width: "100%",
    },
    image: {
        objectFit: "cover",
        width: "100%",
    },
});

export interface IFlyerItem {
    title: string;
    description: string;
    flyerImage: IImageLoader;
    linkAction: string;
    newFlyerTitle: string;
}

export const FlyerItem: FC<IFlyerItem> = (props) => (
    <div {...stylex.props(styles.wrapper)}>
        <div {...stylex.props(styles.header)}>
            <div {...stylex.props(styles.title)}>{props.title}</div>
            <div
                {...stylex.props(styles.description)}
                dangerouslySetInnerHTML={{ __html: props.description }}
            />
        </div>
        {props.newFlyerTitle && <div {...stylex.props(styles.newFlyer)}>{props.newFlyerTitle}</div>}
        <div {...stylex.props(styles.button)}>
            <TransitionLink {...stylex.props(styles.link)} navigateUrl={props.linkAction}>
                <ImageLoader {...stylex.props(styles.image)} {...props.flyerImage} />
            </TransitionLink>
        </div>
    </div>
);
